import { useMemo } from "react";

import { IconButton, Stack } from "@mui/material";
import {
  ChevronLeftDoubleIcon,
  ChevronRightDoubleIcon,
  Menu01Icon,
} from "components/Icon";
import Sidebar from "components/Sidebar";
import { useAppTheme } from "contexts";
import { useIsMobile } from "hooks";
import { Outlet } from "react-router-dom";
import { getPrimaryColor } from "utils/theme";

import { Body, Container, Content } from "./Dashboard.styles";
import { DashboardProps } from "./Dashboard.types";

const Dashboard: React.FC<DashboardProps> = ({
  menu,
  bottomMenu,
  userInfo,
  defaultLanguage,
  languages,
  onLanguageChange,
  onLogout,
}) => {
  const isMobile = useIsMobile();
  const { sidebar, expandSidebarHover } = useAppTheme();
  const collapse = useMemo(
    () => !sidebar.expandedHover && sidebar.collapsed,
    [sidebar.collapsed, sidebar.expandedHover]
  );
  const collapseButtonStyle = useMemo(() => {
    if (collapse)
      return {
        left: "18px",
        top: "54px",
      };
    return {
      left: "126px",
      top: "54px",
    };
  }, [collapse]);
  return (
    <Container>
      <Sidebar
        collapsed={collapse}
        userInfo={userInfo}
        menu={menu}
        bottomMenu={bottomMenu}
        defaultLanguage={defaultLanguage}
        languages={languages}
        onLanguageChange={onLanguageChange}
        onLogout={onLogout}
      />
      <Body
        isMobile={isMobile}
        collapsed={collapse}
        sx={{ position: "relative" }}
      >
        {!isMobile && (
          <Stack
            position="fixed"
            sx={{
              ...collapseButtonStyle,
              transition: "100ms ease-in-out",
            }}
            zIndex={1250}
          >
            <IconButton
              color="primary"
              sx={{ color: "white", padding: 0 }}
              onClick={() => expandSidebarHover?.(collapse)}
            >
              {collapse ? (
                <ChevronRightDoubleIcon sx={{ fontSize: "24px" }} />
              ) : (
                <ChevronLeftDoubleIcon sx={{ fontSize: "24px" }} />
              )}
            </IconButton>
          </Stack>
        )}
        {isMobile && (
          <Stack
            position="fixed"
            bottom="40px"
            left="12px"
            sx={{
              transition: "100ms ease-in-out",
            }}
            zIndex={1000}
          >
            <IconButton
              sx={{ backgroundColor: getPrimaryColor()[700], color: "white" }}
              onClick={() => expandSidebarHover?.(collapse)}
            >
              <Menu01Icon />
            </IconButton>
          </Stack>
        )}

        <Content isMobile={isMobile}>
          <Outlet />
        </Content>
      </Body>
    </Container>
  );
};

export default Dashboard;
